import { useContext } from "react";
import { PermissionsContext } from "@/providers/PermissionsProvider";
import type { EntityPermissions, PermissionEntity } from "@/types/permissions";
import type { PermissionsContextType } from "@/types/providers/permissions";

export type { EntityPermissions, PermissionEntity, PermissionsContextType };

export default function usePermissions(): PermissionsContextType {
  const context = useContext(PermissionsContext);
  if (context === undefined) {
    throw new Error("usePermissions must be used within a PermissionsProvider");
  }
  return context;
}
